import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { addClass, removeClass } from 'app/utils/dom';
import { findTranslate } from 'app/utils/translate';
import { AppStoreState } from 'app/redux/store';
import { useTranslation } from 'next-i18next';
import FacebookCard from "./FacebookCard";
import { useSelector } from 'react-redux';
import { useEffect, useRef } from "react";
import { useRouter } from 'next/router';
import { Blog } from 'types/blog';
import Link from 'next/link';
import env from '.env.json';
import './styles.css';

const Footer = () => {
  const route = useRouter();
  const { t } = useTranslation();
  const isShowScrollUp = useRef(false);
  const { blogs_footer } = useSelector((state: AppStoreState) => state.global);

  useEffect(() => {
    handleScroll();
  }, [])

  const handleScroll = () => {
    window.onscroll = function () {
      if (window.scrollY > 300 && !isShowScrollUp.current) {
        isShowScrollUp.current = true;
        addClass('#scrollUp', 'd-block');
      }

      if (window.scrollY <= 300 && isShowScrollUp.current) {
        isShowScrollUp.current = false;
        removeClass('#scrollUp', 'd-block');
      }
    };
  }

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <footer>
      <div className="footer-main footer-bg" id="footer">
        <div className="footer-bottom-area footer-bg pt-2" style={{ background: "#0077c8" }}>
          <div className="container-md px-2 mx-auto" style={{ maxWidth: '97%' }}>
            <div className="footer-border py-3">
                <div className="footer-copy-right text-center text-white">
                  <p className="px-3 text-size-xl">{t('commons.make_by')}
                    &nbsp;<span className="font-weight-bold">Abudory</span>
                  </p>

                  <div className="pb-4 mx-auto d-block">
                    <FacebookCard showLikeButton={true} />
                  </div>

                  <div className="d-sm-flex my-1 justify-content-center" style={{ lineHeight: 1 }}>
                    {(blogs_footer || [])
                      .filter((blog: Blog) => blog.type == 'policy')
                      .map((blog: Blog) => {
                        return (
                          <Link key={blog.id} className="text-white px-2 text-underline" href={`/news/${blog[`slug_${route?.locale}`]}`}>
                            <p className="cursor-pointer mb-1">{findTranslate(blog?.translates, 'title', route?.locale)}</p>
                          </Link>
                        )
                      })
                    }
                    <Link className="text-white px-2 text-underline" href="/contact">
                      <p className="cursor-pointer mb-1">{t('contacts.contact')}</p>
                    </Link>
                  </div>

                  <p className="text-white">{t('commons.copyright')} © {new Date().getFullYear()} {env.APP_NAME}</p>
                </div>
            </div>
            <button
              onClick={() => scrollToTop()}
              id="scrollUp"
              className="d-none cursor-pointer"
            >
              <FontAwesomeIcon className="text-center" icon={faArrowUp} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer;
